import InvestmentsSummary from "./InvestmentsSummary"

export default InvestmentsSummary
